// Port de app/(tabs)/home.tsx.
import { HomeSkeletonPage } from "@/components/home/HomeSkeleton";
import { useIsFocused } from "@/navigation";
import { Suspense, lazy, useEffect, useState } from "react";
import s from "./home.module.css";

const HomeScreen = lazy(() => import("@/screens/Home"));

// A HomeScreen é GRANDE; montá-la durante a transição trava o clique ("app pesado").
// Aqui a rota ABRE INSTANTANEAMENTE já com o skeleton completo (HomeSkeletonPage, leve)
// e a HomeScreen monta logo depois, POR CIMA, via setTimeout simples — DE PROPÓSITO sem
// InteractionManager: ele pode ser travado por animações em loop (skeleton/liveDot) e
// deixava o loadData/`loading` preso (foto eternamente no skeleton). A Home.tsx NÃO é
// tocada — segue carregando como sempre, então a foto aparece normalmente.
export default function HomeRoute() {
  const focused = useIsFocused();
  const [pronto, setPronto] = useState(false);

  useEffect(() => {
    if (!focused) {
      setPronto(false);
      return;
    }
    const t = setTimeout(() => setPronto(true), 100);
    return () => clearTimeout(t);
  }, [focused]);

  if (!focused) return null;
  // SWAP (não overlay): quando a HomeScreen fica pronta, o skeleton é DESMONTADO. No
  // Android o `elevation` da sombra do avatar do skeleton podia renderizar POR CIMA da
  // HomeScreen e esconder a foto real — com o swap não há backdrop atrás, nada cobre a
  // foto. O fundo #f2f7f9 do container evita flash branco no fade-in do PageFragment.
  // WEB: enquanto o chunk da Home ainda carrega (lazy), o skeleton continua na tela.
  return (
    <div className={s.container}>
      {pronto ? (
        <Suspense fallback={<HomeSkeletonPage />}>
          <HomeScreen />
        </Suspense>
      ) : (
        <HomeSkeletonPage />
      )}
    </div>
  );
}
